var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "#2C3038",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 7.33409L3.66675 14.6674V18.3341L7.33341 18.3341L14.6667 11.0007M11.0001 7.33409L13.6297 4.70449L13.6312 4.70293C13.9932 4.34096 14.1745 4.15965 14.3835 4.09174C14.5676 4.03192 14.766 4.03192 14.9501 4.09174C15.1589 4.1596 15.34 4.3407 15.7015 4.70217L17.2963 6.29698C17.6593 6.65999 17.8409 6.84159 17.9089 7.05089C17.9687 7.23499 17.9687 7.43331 17.9089 7.61742C17.8409 7.82657 17.6596 8.00788 17.2971 8.37038L17.2963 8.37116L14.6667 11.0007M11.0001 7.33409L14.6667 11.0007",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.85f29cc7b597ed58c9fcb671b129316d.svg";